import React, { useEffect, useRef, useState } from "react";
import { Form, Input } from "antd";

export const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (editing) {
      inputRef.current?.focus();
    }
  }, [editing]);

  const inputNode = <Input ref={inputRef} />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: dataIndex === "email" || dataIndex === "name",
              message: `Please Input ${title}!`,
            },
            dataIndex === "email"
              ? {
                  type: "email",
                  message: "Please enter a valid email address",
                }
              : null,
          ].filter(Boolean)}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
